import { Link } from "react-router-dom"
import Menu from "./Menu"
import cursor from "../assets/img/cursor.png"

const Home = () => {

  return (        
          <div>
          <p id='intro'>Hello, I am Luwenxi.
          <br></br>
          <p id='start'>Click a cursor to start.</p></p>
          <Link to="/Contact"><img id='menu0'src={cursor} alt='contact'></img></Link>
          <Menu></Menu>
          </div>
      )
  };
  
  export default Home;